<div class="dialog-title">Update API</div>
<div class="dialog-description">Select API Version</div>
<!-- <form [formGroup]="apiVerForm"> -->
  <mat-form-field>
    <input type="text" placeholder="API Version" required matInput [matAutocomplete]="auto" [(ngModel)]="ngModelData" (ngModelChange)="onChangeSearchedApi($event)"/>
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayApiVersion">
      <mat-option *ngFor="let dat of dialogData" [value]="dat" (click)="onChangeSelectedApi(dat)">
        <div class="xsTitle-f">{{dat.version}}</div>
      </mat-option>
    </mat-autocomplete>
    <mat-error>API Version is required</mat-error>

  </mat-form-field>
<!-- </form> -->
<div class="dialog-buttons">
  <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
  <button mat-button color="primary" (click)="save()" [mat-dialog-close]="false">Save</button>
</div>